const howToWearStrings = () => document.querySelector('.how-to-wear__wrapper')?.dataset || {}

// How to Wear Section JavaScript - Web Components
document.addEventListener('DOMContentLoaded', () => {
  console.log('How to Wear section loaded')

  // Initialize legacy functionality for any existing elements
  initVariantSelection()

  // Initialize variant popups
  initVariantPopups()

  // Initialize main add-to-cart buttons to open popups
  initMainAddToCartButtons()
})

// Initialize Variant Popups
function initVariantPopups () {
  const variantPopups = document.querySelectorAll('.variant-popup')

  variantPopups.forEach(popup => {
    const content = popup.querySelector('.variant-popup__content')
    const closeBtn = popup.querySelector('.variant-popup__close')
    const cardWrapper = popup.closest('.card-wrapper')

    if (!content) return

    // Handle close button click
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        popup.classList.remove('active')
      })
    }

    // Handle clicks outside popup to close it
    document.addEventListener('click', (e) => {
      if (!popup.contains(e.target) && !e.target.closest('.pdp-add-to-cart')) {
        popup.classList.remove('active')
      }
    })

    // Prevent popup content clicks from closing or navigating
    content.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
    })

    // Handle variant selection within popup
    const variantButtons = popup.querySelectorAll('.variant-option')
    variantButtons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault()
        e.stopPropagation()

        if (this.disabled || this.classList.contains('variant-option--unavailable')) {
          return
        }

        // Remove selected state from other buttons
        variantButtons.forEach(btn => btn.classList.remove('selected'))

        // Add selected state to clicked button
        this.classList.add('selected')

        // Enable add to cart button in popup
        const addToCartBtn = popup.querySelector('.btn-add-to-cart--popup')
        if (addToCartBtn) {
          addToCartBtn.disabled = false
        }

        // Dispatch variant selected event
        const event_detail = {
          variantId: this.dataset.variantId,
          variantTitle: this.dataset.variantTitle,
          productId: popup.dataset.productId,
        }

        popup.dispatchEvent(new CustomEvent('variant-selected', {
          detail: event_detail,
          bubbles: true,
        }))
      })
    })

    // Handle add to cart within popup
    const addToCartBtn = popup.querySelector('.btn-add-to-cart')
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', async (e) => {
        e.preventDefault()
        e.stopPropagation()

        const selectedVariant = popup.querySelector('.variant-option.selected')
        if (!selectedVariant) {
          alert(howToWearStrings().selectSizeText)
          return
        }

        const variantId = selectedVariant.dataset.variantId

        // Use the existing add to cart logic
        const tempAddToCartButton = document.createElement('add-to-cart-button')
        tempAddToCartButton.setAttribute('data-product-id', popup.dataset.productId)
        tempAddToCartButton.selectedVariantId = variantId
        tempAddToCartButton.button = addToCartBtn
        tempAddToCartButton.isLoading = false

        await tempAddToCartButton.addToCart(variantId)

        // Close popup after successful add to cart
        setTimeout(() => {
          popup.classList.remove('active')
        }, 1000)
      })
    }

    // Prevent card link from being triggered when interacting with popup
    popup.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
    })
  })
}

// Initialize Main Add-to-Cart Buttons to Open Popups
function initMainAddToCartButtons () {
  const openPopupButtons = document.querySelectorAll('.pdp-add-to-cart .btn-open-popup')

  openPopupButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault()
      e.stopPropagation()

      // Find the corresponding popup for this product
      const addToCartComponent = this.closest('add-to-cart-button')
      const productId = addToCartComponent ? addToCartComponent.getAttribute('data-product-id') : null

      if (productId) {
        const popup = document.querySelector(`.variant-popup[data-product-id="${productId}"]`)
        if (popup) {
          // Close other popups
          document.querySelectorAll('.variant-popup.active').forEach(p => {
            if (p !== popup) p.classList.remove('active')
          })

          // Open the popup
          popup.classList.add('active')
        }
      }
    })
  })
}

// Variant Selector Web Component
class VariantSelector extends HTMLElement {
  constructor () {
    super()
    this.selectedVariantId = null
    this.productId = this.getAttribute('data-product-id')
    this.init()
  }

  init () {
    this.addEventListener('click', this.handleVariantClick.bind(this))
    this.dispatchEvent(new CustomEvent('variant-selector:ready', {
      detail: { productId: this.productId },
    }))

    console.log('VariantSelector initialized for product:', this.productId)
  }

  handleVariantClick (event) {
    const variantButton = event.target.closest('.variant-option')
    if (!variantButton) return

    event.preventDefault()
    event.stopPropagation()

    console.log('Variant button clicked:', variantButton.dataset.variantTitle)

    // Don't allow selection of unavailable variants
    if (variantButton.disabled || variantButton.classList.contains('variant-option--unavailable')) {
      console.log('Variant is unavailable, not selecting')
      return
    }

    // Remove selected class from all buttons in this container
    this.querySelectorAll('.variant-option').forEach(btn => btn.classList.remove('selected'))

    // Add selected class to clicked button
    variantButton.classList.add('selected')

    // Store selected variant ID
    this.selectedVariantId = variantButton.dataset.variantId

    // Dispatch event to notify add to cart button
    const event_detail = {
      variantId: this.selectedVariantId,
      variantTitle: variantButton.dataset.variantTitle,
      productId: this.productId,
    }

    console.log('Dispatching variant-selected event:', event_detail)

    this.dispatchEvent(new CustomEvent('variant-selected', {
      detail: event_detail,
      bubbles: true,
    }))

    // Also dispatch globally for debugging
    document.dispatchEvent(new CustomEvent('variant-selected', {
      detail: event_detail,
      bubbles: true,
    }))

    console.log('Selected variant:', this.selectedVariantId, variantButton.dataset.variantTitle)
  }

  getSelectedVariant () {
    return this.selectedVariantId
  }

  reset () {
    this.querySelectorAll('.variant-option').forEach(btn => btn.classList.remove('selected'))
    this.selectedVariantId = null
  }
}

// Add to Cart Button Web Component
class AddToCartButton extends HTMLElement {
  constructor () {
    super()
    this.productId = this.getAttribute('data-product-id')
    this.selectedVariantId = null
    this.isLoading = false
    this.button = null
    this.init()
  }

  init () {
    // Get the actual button element inside this component
    this.button = this.querySelector('.btn-add-to-cart')

    if (!this.button) {
      console.error('Add to cart button element not found inside component')
      return
    }

    this.button.addEventListener('click', this.handleAddToCart.bind(this))

    // Listen for variant selection events
    document.addEventListener('variant-selected', this.handleVariantSelected.bind(this))

    // Ensure button is disabled initially
    // this.button.disabled = true;

    console.log('AddToCartButton initialized for product:', this.productId)
  }

  handleVariantSelected (event) {
    console.log('AddToCartButton received variant-selected event:', event.detail)

    if (event.detail.productId === this.productId) {
      this.selectedVariantId = event.detail.variantId
      this.button.disabled = false
      console.log('Button enabled for product:', this.productId, 'variant:', this.selectedVariantId)
    }
  }

  async handleAddToCart (event) {
    event.preventDefault()
    event.stopPropagation()

    if (!this.selectedVariantId) {
      alert(howToWearStrings().selectSizeText)
      return
    }

    if (this.isLoading) return

    await this.addToCart(this.selectedVariantId)
  }

  async addToCart (variantId) {
    const addToCartText = this.querySelector('.add-to-cart-text')
    const addToCartLoading = this.querySelector('.add-to-cart-loading')

    // Show loading state
    this.isLoading = true
    this.button.disabled = true
    if (addToCartText) addToCartText.style.display = 'none'
    if (addToCartLoading) addToCartLoading.style.display = 'flex'

    try {
      const formData = new FormData()
      formData.append('id', variantId)
      formData.append('quantity', 1)

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData,
      })

      if (response.ok) {
        const result = await response.json()
        console.log('Added to cart:', result)

        // Show success feedback
        if (addToCartText) {
          addToCartText.textContent = howToWearStrings().addedText
          addToCartText.style.display = 'flex'
        }
        if (addToCartLoading) addToCartLoading.style.display = 'none'

        // Update cart count and refresh cart drawer contents
        await this.updateCartAndDrawer()

        // Reset button after 2 seconds
        setTimeout(() => {
          if (addToCartText) addToCartText.textContent = howToWearStrings().addToCartText
          this.button.disabled = false
          this.isLoading = false
        }, 2000)

        // Open cart drawer after ensuring it's updated
        setTimeout(() => {
          this.openCartDrawer()
        }, 100)

        // Dispatch success event
        this.dispatchEvent(new CustomEvent('item-added-to-cart', {
          detail: { result, variantId },
          bubbles: true,
        }))
      } else {
        const errorData = await response.json()
        throw new Error(errorData.description || 'Failed to add to cart')
      }
    } catch (error) {
      console.error('Error adding to cart:', error)
      alert(howToWearStrings().cartErrorText)

      // Reset button state
      if (addToCartText) addToCartText.style.display = 'flex'
      if (addToCartLoading) addToCartLoading.style.display = 'none'
      this.button.disabled = false
      this.isLoading = false
    }
  }

  async updateCartAndDrawer () {
    try {
      // Fetch updated cart data
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
      const cart = await cartResponse.json()

      // Calculate cart count excluding child/bundled items
      let cartCount = 0
      if (cart.items && Array.isArray(cart.items)) {
        for (const item of cart.items) {
          // Skip items that have a parent (bundled/child items)
          if (!item.parent_relationship?.parent_key) {
            cartCount += item.quantity
          }
        }
      } else {
        // Fallback to item_count if items array not available
        cartCount = cart.item_count
      }

      // Update cart count
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble')
      cartCountElements.forEach(element => {
        element.textContent = cartCount
        if (cartCount > 0) {
          element.style.display = 'flex'
        }
      })

      // Force refresh cart drawer contents
      await this.refreshCartDrawer()

      // Dispatch cart update event for other components
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))

      return cart
    } catch (error) {
      console.error('Error updating cart:', error)
    }
  }

  async refreshCartDrawer () {
    // Try multiple methods to refresh cart drawer
    const cartDrawer = document.querySelector('cart-drawer')
    const cartDrawerAlt = document.querySelector('[data-cart-drawer]') || document.querySelector('.cart-drawer')

    if (cartDrawer) {
      // Method 1: Call refresh method if it exists
      if (typeof cartDrawer.refresh === 'function') {
        cartDrawer.refresh()
      }
      // Method 2: Trigger cart update if method exists
      else if (typeof cartDrawer.updateCart === 'function') {
        cartDrawer.updateCart()
      }
      // Method 3: Dispatch custom event that cart drawer might listen to
      else {
        cartDrawer.dispatchEvent(new CustomEvent('cart:refresh'))
      }
    } else if (cartDrawerAlt) {
      // Similar methods for alternative cart drawer
      if (typeof cartDrawerAlt.refresh === 'function') {
        cartDrawerAlt.refresh()
      } else if (typeof cartDrawerAlt.updateCart === 'function') {
        cartDrawerAlt.updateCart()
      } else {
        cartDrawerAlt.dispatchEvent(new CustomEvent('cart:refresh'))
      }
    }

    // Try to refresh cart drawer by fetching new HTML content
    try {
      // Try different approaches to refresh cart drawer content
      const possibleSelectors = [
        'cart-drawer .drawer__inner',
        '.cart-drawer .drawer__inner',
        '[data-cart-drawer] .drawer__inner',
        'cart-drawer .cart-drawer__inner',
        '.cart-drawer .cart-drawer__inner',
        'cart-drawer',
        '.cart-drawer',
      ]

      let cartDrawerContent = null
      for (const selector of possibleSelectors) {
        cartDrawerContent = document.querySelector(selector)
        if (cartDrawerContent) break
      }

      if (cartDrawerContent) {
        // Try to fetch cart drawer section
        const response = await fetch('/?section_id=cart-drawer')
        if (response.ok) {
          const html = await response.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')

          // Try to find the matching content in the response
          let newContent = null
          for (const selector of possibleSelectors) {
            newContent = doc.querySelector(selector)
            if (newContent) break
          }

          if (newContent) {
            cartDrawerContent.innerHTML = newContent.innerHTML
          }
        }
      }
    } catch (error) {
      console.log('Could not refresh cart drawer content via section fetch:', error)
    }

    // Alternative approach: Try to refresh using cart API and update manually
    try {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
      const cartData = await cartResponse.json()

      // Dispatch a more specific cart update event
      document.dispatchEvent(new CustomEvent('cart:items-updated', {
        detail: {
          cart: cartData,
          source: 'how-to-wear-add-to-cart',
        },
      }))

      // Try to trigger theme's cart update mechanism
      if (window.theme && window.theme.cartUpdate) {
        window.theme.cartUpdate(cartData)
      }
    } catch (error) {
      console.log('Could not refresh cart drawer via cart API:', error)
    }
  }

  openCartDrawer () {
    // Try multiple ways to open cart drawer
    const cartDrawer = document.querySelector('cart-drawer')
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open()
      return
    }

    // Try alternative selectors
    const cartDrawerAlt = document.querySelector('[data-cart-drawer]') || document.querySelector('.cart-drawer')
    if (cartDrawerAlt && typeof cartDrawerAlt.open === 'function') {
      cartDrawerAlt.open()
      return
    }

    // Try to find and click cart icon/button to open drawer
    const cartButtons = [
      '[data-cart-open]',
      '.cart-link',
      '.header__icon--cart',
      '[data-cart-toggle]',
      '.cart-toggle',
      '.cart-icon',
      '.header-cart',
      '[aria-label*="cart" i]',
      '[aria-label*="shopping" i]',
    ]

    for (const selector of cartButtons) {
      const cartButton = document.querySelector(selector)
      if (cartButton) {
        cartButton.click()
        return
      }
    }

    // Try to dispatch cart drawer open event
    document.dispatchEvent(new CustomEvent('cart:open'))
  }
}

// Register the web components
customElements.define('variant-selector', VariantSelector)
customElements.define('add-to-cart-button', AddToCartButton)

// Ensure components are properly initialized
function ensureComponentsInitialized () {
  // Check for any uninitialized variant selectors
  const variantSelectors = document.querySelectorAll('variant-selector')
  variantSelectors.forEach(selector => {
    if (!selector.productId) {
      console.log('Re-initializing variant selector:', selector)
      selector.productId = selector.getAttribute('data-product-id')
      selector.init()
    }
  })

  // Check for any uninitialized add to cart buttons
  const addToCartButtons = document.querySelectorAll('add-to-cart-button')
  addToCartButtons.forEach(button => {
    if (!button.button) {
      console.log('Re-initializing add to cart button:', button)
      button.productId = button.getAttribute('data-product-id')
      button.init()
    }
  })

  // Re-initialize variant popups
  initVariantPopups()

  // Re-initialize main add-to-cart buttons
  initMainAddToCartButtons()
}

// Run initialization after a delay to ensure DOM is ready
setTimeout(ensureComponentsInitialized, 500)

// Also run when DOM content is fully loaded
document.addEventListener('DOMContentLoaded', ensureComponentsInitialized)

// Debug function to test component communication
window.debugHowToWear = function () {
  console.log('=== How to Wear Debug Info ===')

  const variantSelectors = document.querySelectorAll('variant-selector')
  console.log('Found variant selectors:', variantSelectors.length)
  variantSelectors.forEach((selector, index) => {
    console.log(`Selector ${index}:`, {
      productId: selector.productId,
      selectedVariant: selector.selectedVariantId,
      element: selector,
    })
  })

  const addToCartButtons = document.querySelectorAll('add-to-cart-button')
  console.log('Found add to cart buttons:', addToCartButtons.length)
  addToCartButtons.forEach((button, index) => {
    console.log(`Button ${index}:`, {
      productId: button.productId,
      selectedVariant: button.selectedVariantId,
      buttonElement: button.button,
      disabled: button.button ? button.button.disabled : 'unknown',
      element: button,
    })
  })
}

// Legacy function for backward compatibility
function initVariantSelection () {
  const variantContainers = document.querySelectorAll('.how-to-wear-variants:not(variant-selector)')

  variantContainers.forEach(container => {
    const variantButtons = container.querySelectorAll('.variant-option')
    const productId = container.dataset.productId

    // Find the add to cart button - it might be in the same container or in a sibling container
    let addToCartButton = container.querySelector('.btn-add-to-cart')
    if (!addToCartButton) {
      // Look for add to cart button in the parent card
      const cardWrapper = container.closest('.card-wrapper')
      if (cardWrapper) {
        addToCartButton = cardWrapper.querySelector('.btn-add-to-cart')
      }
    }

    if (!addToCartButton) {
      console.warn('Add to cart button not found for product:', productId)
      return
    }

    let selectedVariantId = null

    // Handle variant button clicks
    variantButtons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault()
        e.stopPropagation()

        // Don't allow selection of unavailable variants
        if (this.disabled || this.classList.contains('variant-option--unavailable')) {
          return
        }

        // Remove selected class from all buttons in this container
        variantButtons.forEach(btn => btn.classList.remove('selected'))

        // Add selected class to clicked button
        this.classList.add('selected')

        // Store selected variant ID
        selectedVariantId = this.dataset.variantId

        // Enable add to cart button
        addToCartButton.disabled = false

        console.log('Selected variant:', selectedVariantId, this.dataset.variantTitle)
      })
    })

    // Handle add to cart button click
    addToCartButton.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (!selectedVariantId) {
        alert(howToWearStrings().selectSizeText)
        return
      }

      // Create a temporary add-to-cart-button element to reuse the logic
      const tempAddToCartButton = document.createElement('add-to-cart-button')
      tempAddToCartButton.setAttribute('data-product-id', productId)
      tempAddToCartButton.selectedVariantId = selectedVariantId
      tempAddToCartButton.addToCart(selectedVariantId)
    })
  })
}

function updateCartCount () {
  // This function is now replaced by updateCartAndDrawer in the web component
  const addToCartButtons = document.querySelectorAll('add-to-cart-button')
  if (addToCartButtons.length > 0) {
    addToCartButtons[0].updateCartAndDrawer()
  }
}
